import { Router } from 'vue-router'
import { TOKENKEY } from '@/config/constant'
import { setStorage, getStorage } from '@/utils'
import { setGlobelHeader } from '@/utils/request'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

NProgress.configure({
  easing: 'ease', // 动画方式
  speed: 500, // 递增进度条的速度
  showSpinner: false, // 是否显示加载ico
  trickleSpeed: 200, // 自动递增间隔
  minimum: 0.2, // 初始化时的最小百分比
})

export default function (router: Router): void {
  try {
    const token = getStorage<string>(TOKENKEY)
    token && setGlobelHeader('token', token)
  } catch (error) {
    console.log('Hook', error)
  }

  router.beforeEach((to, from, next) => {
    NProgress.start()
    if (to.query.token || to.query.access_token) {
      const token = to.query.token || to.query.access_token
      setGlobelHeader('token', token)
      setStorage(TOKENKEY, token as string)
      // if (process.env.NODE_ENV !== 'development') {
      //   // 测试环境先不用移除token先
      //   delete to.query.token
      //   next(to)
      //   return
      // }
    }
    next()
  })

  router.afterEach(() => {
    NProgress.done()
  })
}
